import React, { useEffect, useState } from 'react'
import { buildUrl } from '../helper/handler';
import { getFromApi } from '../utilities/NetUtilities';
import { getPostazioneDesc, getSede, daMinutiAOre, getMilliseconds } from './turniHelper';
import { TurniGiornoSede } from "./TurniGiornoSede";
import { TotaleOre } from "./TotaleOre";
import moment from "moment";
import { downloadFile } from '../utilities/NetUtilities';
import { Button } from "react-bootstrap";

function TabellaOrarioPerSede(props) {

    const [sedi, setSedi] = useState();
    const [turni, setTurni] = useState(null)
    const [sede, setSede] = useState(null)
    const [settimana, setSettimana] = useState(null)
    const [csvUrl, setCsvUrl] = useState("");
    const [totalWeeklyMinutes, setTotalWeeklyMinutes] = useState(0);


    const isLoaded = () => {
        return sedi && sedi.length > 0 && sede === props.sede.value && settimana === props.settimana;
    };

    useEffect(() => {
        const organizzazioneMap = JSON.parse(window.sessionStorage.getItem("organizzazione"));
        const setSediFromApi = (data) => {
            setSedi(data.sedi);
        }
        const setMessageFromApi = (data) => {
            props.setMessage(message => [...message, { tipo: data.messaggi[0].tipo, descrizione: data.messaggi[0].descrizione }])
        }
        const setTurniFromApi = (data) => {
            setTurni(data.turni);
            setSede(props.sede.value);
            setSettimana(props.settimana);
        }
        const getTurni = (sede, settimana) => {
            if (sede && settimana && organizzazioneMap) {
                const url = buildUrl('turniPerSede', { sede: sede, settimana: settimana, organizzazione: organizzazioneMap.nome, tipo: organizzazioneMap.tipo });
                getFromApi(url, setTurniFromApi, setMessageFromApi);
            }
        }
        if (organizzazioneMap) {
            const url = buildUrl('sedi', { organizzazione: organizzazioneMap.nome, tipo: organizzazioneMap.tipo });
            getFromApi(url, setSediFromApi, setMessageFromApi);
            getTurni(props.sede.value, props.settimana);
        }
        if (organizzazioneMap && props.sede && props.settimana) {
            const params = {
                sede: props.sede.value,
                settimana: props.settimana,
                organizzazione: organizzazioneMap.nome,
                tipo: organizzazioneMap.tipo
            };
            setCsvUrl(buildUrl('turniPerSedeCsv', params));
        }
    }, [props]);
    
    useEffect(() => {
        if (!turni) {
            setTotalWeeklyMinutes(0);
            return;
        };

        let totalMinutes = 0;
        Object.values(turni).forEach(day => {
            Object.values(day).forEach(postazione => {
                const allShifts = [...(postazione.mattina || []), ...(postazione.pomeriggio || [])];
                allShifts.forEach(turno => {
                    totalMinutes += getMilliseconds(turno.inizio, turno.fine) / (1000 * 60);
                });
            });
        });
        setTotalWeeklyMinutes(totalMinutes);
    }, [turni]);


    const printTurniPerSede = (data, turniGiornoSede, dayIndex) => {
        const dayRows = [];
        const sedeCompleta = getSede(sedi, sede);
        if (!sedeCompleta) return [];

        const postazioniDelGiorno = sedeCompleta.postazioni ? Object.keys(sedeCompleta.postazioni) : [];
        let dayTotalMattina = 0;
        let dayTotalPomeriggio = 0;
        const dayIdPrefix = moment(data).format('dddd').toLowerCase();

        postazioniDelGiorno.forEach((postazioneId, postazioneIndex) => {
            const descPostazione = getPostazioneDesc(sedeCompleta.postazioni, postazioneId);
            const turniPostazione = turniGiornoSede[postazioneId] || { mattina: [], pomeriggio: [] };
            const rowClass = dayIndex % 2 === 0 ? 'lineaGrigia' : 'lineaBianca';

            const postazioneMattinaMinutes = turniPostazione.mattina.reduce((acc, t) => acc + (getMilliseconds(t.inizio, t.fine) / (1000 * 60)), 0);
            const postazionePomeriggioMinutes = turniPostazione.pomeriggio.reduce((acc, t) => acc + (getMilliseconds(t.inizio, t.fine) / (1000 * 60)), 0);
            dayTotalMattina += postazioneMattinaMinutes;
            dayTotalPomeriggio += postazionePomeriggioMinutes;
            
            dayRows.push(
                <tr key={`${data}-${postazioneId}`} className={rowClass}>
                    {postazioneIndex === 0 && (
                        <td className="inEvidenza bordiSpessi" rowSpan={postazioniDelGiorno.length}>
                            {moment(data).format('dddd DD MMMM')}
                        </td>
                    )}
                    <td className="inEvidenza bordiSpessi">{descPostazione}</td>
                    <td className="bordiSpessi">
                        <TurniGiornoSede
                            setMessage={props.setMessage}
                            sedi={sedi}
                            sede={props.sede}
                            postazione={postazioneId}
                            servizi={props.servizi}
                            giorno={data}
                            mattina={true}
                            turni={turniPostazione.mattina}
                            lavoratoreDisable={false}
                            postazioneDisable={true}
                            sedeDisable={true}
                            index={`${moment(data).format('dddd')}${postazioneIndex}mattina`}
                            lavoratori={props.lavoratori}
                            setRefreshSettimaneConTurni={props.setRefreshSettimaneConTurni}
                        />
                    </td>
                    <td className='orario bordiSpessi'>
                        <TotaleOre
                            turni={turniPostazione.mattina}
                            index={`${moment(data).format('dddd')}${postazioneIndex}mattinatotore`}
                        />
                    </td>
                    <td className="bordiSpessi">
                        <TurniGiornoSede
                            setMessage={props.setMessage}
                            sedi={sedi}
                            sede={props.sede}
                            postazione={postazioneId}
                            servizi={props.servizi}
                            giorno={data}
                            mattina={false}
                            turni={turniPostazione.pomeriggio}
                            lavoratoreDisable={false}
                            postazioneDisable={true}
                            sedeDisable={true}
                            index={`${moment(data).format('dddd')}${postazioneIndex}pomeriggio`}
                            lavoratori={props.lavoratori}
                            setRefreshSettimaneConTurni={props.setRefreshSettimaneConTurni}
                        />
                    </td>
                    <td className='orario bordiSpessi'>
                        <TotaleOre
                            turni={turniPostazione.pomeriggio}
                            index={`${moment(data).format('dddd')}${postazioneIndex}pomeriggiototore`}
                        />
                    </td>
                </tr>
            );
        });

        dayRows.push(
            <tr key={`${data}-total`} className="evidenziazione">
                <td className="inEvidenza bordiSpessi">Totale del giorno</td>
                <td className="orario bordiSpessi inEvidenza" id={`${dayIdPrefix}-totale-giornaliero`}>{daMinutiAOre(dayTotalMattina + dayTotalPomeriggio)}</td>
                <td className="inEvidenza bordiSpessi text-left">Totale ore mattina</td>
                <td className="orario bordiSpessi inEvidenza" id={`${dayIdPrefix}-totale-mattina`}>{daMinutiAOre(dayTotalMattina)}</td>
                <td className="inEvidenza bordiSpessi text-left">Totale ore pomeriggio</td>
                <td className="orario bordiSpessi inEvidenza" id={`${dayIdPrefix}-totale-pomeriggio`}>{daMinutiAOre(dayTotalPomeriggio)}</td>
            </tr>
        );
        return dayRows;
    }

    const printTurni = () => {
        if (!turni) return null;
        return Object.keys(turni).flatMap((data, index) => {
            const turniGiornoSede = turni[data];
            return printTurniPerSede(data, turniGiornoSede, index);
        });
    }

    return (
        <div>
            {isLoaded() && turni && (
                <div className="d-flex justify-content-between align-items-center space">
                    <h4 className="inEvidenza mb-0" id="totale_ore_settimanali">
                        Totale ore settimanali: {daMinutiAOre(totalWeeklyMinutes)}
                    </h4>
                    <Button
                        data-toggle="tooltip"
                        title="Download Excel"
                        className='btnGeneraleVariante'
                        variant="flat"
                        size="sm"
                        id="csv-turni-sede"
                        onClick={() => { downloadFile(csvUrl, "turni-sede.xlsx") }}
                    >scarica</Button>
                </div>
            )}
            <table className="table table-bordered bordiSpessi" key="tabellapersede">
                <thead className="App tableTurniLavoro">
                    <tr key="intestazione">
                        <th className="inEvidenza bordiSpessi">giorno</th>
                        <th className="inEvidenza bordiSpessi">postazione</th>
                        <th className="inEvidenza bordiSpessi">mattina</th>
                        <th className="inEvidenza bordiSpessi">totale (hh:mm)</th>
                        <th className="inEvidenza bordiSpessi">pomeriggio</th>
                        <th className="inEvidenza bordiSpessi">totale (hh:mm)</th>
                    </tr>
                </thead>
                <tbody>
                    {isLoaded() && turni && printTurni()}
                </tbody>
            </table>
        </div>
    )
}

export default TabellaOrarioPerSede;